export default __webpack_public_path__ + "static/media/Boxcheck_Logo_Primary.3ccadaf3.png";